import {SystemicGrammarEntryDto} from './systemic-grammar-entry-dto';

export class SystemicGrammarCategoryDto {
  constructor(
    public id: number,
    public name: string,
    public subcategories: SystemicGrammarCategoryDto[],
    public parent: SystemicGrammarCategoryDto,
    public parentId: number,
    public parentName: string,
    public systemicGrammarEntries: SystemicGrammarEntryDto[]
  ) {
  }
}
